import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  Textarea,
  useBreakpointValue,
} from "@chakra-ui/react";
const birthstoneOptions = [
  "January - Blue",
  "March - Purple",
  "April - Red",
  "May - Pink",
  "June - White",
  "July - Ruby Red",
  "August - Coral Red",
  "September - Grey",
  "October - Lavender",
  "November - Yellow",
  "December - Orange",
];

const PersonalizationModel = ({
  isOpen,
  onClose,
  engraving,
  birthstone,
  onChangeEngraving,
  onChangeBirthstone,
}) => {
 
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size={isMobile ? "xs" : "md"}
    >
      <ModalOverlay />
      <ModalContent p={4}>
        <ModalHeader fontSize="2xl">Personalize It</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4}>
            <FormLabel>Engraving (Optional)</FormLabel>
            <Textarea
              placeholder="Enter engraving if you feel inspired"
              value={engraving}
              onChange={(e) =>
            e.target.value.length <= 20 && onChangeEngraving(e.target.value)
          }
            />
            <Box
              display="flex"
              justifyContent="space-between"
              fontSize="sm"
              mt={1}
            >
              <Text>{engraving.length} Character</Text>
              <Text>Max 20 Character</Text>
            </Box>
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Birth Stone</FormLabel>
            <Select
              placeholder="Select birth stone according to your birth month"
             value={birthstone}
             onChange={(e) => onChangeBirthstone(e.target.value)}
            >
              {birthstoneOptions.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </Select>
          </FormControl>

          <Text fontSize="xs" color="orange.600" mt={2}>
            Customized Items Cannot Be Returned.
            <br />
            Allow An Additional 7–10 Business Days For Processing And Delivery
            Time.
          </Text>

          <Button
            mt={4}
            width="100%"
            bg="#002D2D"
            color="white"
            onClick={onClose}
          >
            SAVE
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PersonalizationModel;
